import { Injectable } from "@angular/core";
import { ActivatedRoute, NavigationEnd, ParamMap, Router } from "@angular/router";
import { firstValueFrom } from "rxjs";

/**
 * A service for getting the query parameters even at the app component level outside of the router outlet.
 */
@Injectable({
  providedIn: 'root'
})
export class TopLevelQueryParamHelperService {

  /**
   * Initializes a new instance of the {@link TopLevelQueryParamHelperService} class.
   * @param route The activated route to walk down.
   * @param router The angular router for subscribe to the routing events.
   */
  constructor(
    private route: ActivatedRoute,
    private router: Router) {
  }

  /**
   * Gets the query param map even for the the app component level outside of the router outlet.
   * @returns A promise containing the param map.
   */
  public GetTopLevelQueryParamMap(): Promise<ParamMap> {
    return new Promise((resolve, reject) => {
      this.router.events.subscribe(async event => {
        if (event instanceof NavigationEnd) {
          // Traverse the active route tree
          let activatedChild = this.route.firstChild;
          if (activatedChild != null) {
            let nextActivatedChild;
            while (nextActivatedChild != null) {
              nextActivatedChild = activatedChild!.firstChild;
              if (nextActivatedChild != null) {
                activatedChild = activatedChild!.firstChild;
              }
            }
          }
          var deeperActivatedRoute = activatedChild || this.route;
          var queryParamMap = await firstValueFrom(deeperActivatedRoute.queryParamMap);
          resolve(queryParamMap);
        }
      });
    });
  }
}